module.exports = __webpack_public_path__ + "catalog/items/espacios_41/3D_4.1_SIM.mtl";